import React, { useState, useEffect } from 'react';
import './NewCategoria.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../url';
import Swal from 'sweetalert2';
import { fetchUsuario, getUsuario } from '../../user';
import planes from '../../planes';

// 🔥 ICONO (AGREGADO)
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolderPlus } from '@fortawesome/free-solid-svg-icons';

export default function NewCategoria() {

    // 🔹 Estados
    const [mensaje, setMensaje] = useState('');
    const [categoria, setCategoria] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const [categorias, setCategorias] = useState([]);
    const [imagen, setImagen] = useState(null);
    const [previewImagen, setPreviewImagen] = useState(null);

    // 🔹 Usuario
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            await fetchUsuario();
            setLoading(false);
        };
        fetchData();
    }, []);

    const usuarioLegued = getUsuario();

    // 🔹 Abrir / cerrar modal
    const toggleModal = () => {
        setCategoria('');
        setMensaje('');
        setImagen(null);
        setPreviewImagen(null);
        setModalOpen(!modalOpen);
    };

    // 🔹 Cargar categorías
    useEffect(() => {
        cargarCategoria();
    }, []);

    const cargarCategoria = () => {
        fetch(`${baseURL}/categoriasGet.php`)
            .then(response => response.json())
            .then(data => {
                setCategorias(data.categorias || []);
            })
            .catch(error => console.error('Error al cargar categorías:', error));
    };

    // 🔥 CREAR CATEGORÍA
    const crear = async () => {

        const nueva = categoria.toLowerCase().trim();

        const existe = categorias.some(
            cat => cat.categoria.toLowerCase().trim() === nueva
        );

        if (existe) {
            Swal.fire('Error', 'La categoría ya existe', 'warning');
            return;
        }

        const formData = new FormData();
        formData.append('categoria', categoria);
        if (imagen) {
            formData.append('imagen', imagen);
        }

        setMensaje('Procesando...');

        try {
            const response = await fetch(`${baseURL}/categoriasPost.php`, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();

            if (data.mensaje) {
                setMensaje('');
                toast.success(data.mensaje);
                toggleModal();
                window.location.reload();
            } else if (data.error) {
                setMensaje('');
                toast.error(data.error);
            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            toast.error('Error de conexión. Por favor, inténtelo de nuevo.');
        }
    };

    // 🔹 Plan
    const plan = planes[0]?.plan;
    const limitePlan = planes[0]?.limiteCategoria;

    const mensagePlan = `¡Alcanzaste el límite del plan ${plan}! 
    Tu límite son ${limitePlan} categorias`;

    const alertPlan = () => {
        Swal.fire('¡Error!', mensagePlan, 'error');
    };

    // 🔹 Validación UX
    const nueva = categoria.toLowerCase().trim();

    const existe = categorias.some(
        cat => cat.categoria.toLowerCase().trim() === nueva
    );

    return (
        <div className='NewContain'>
            <ToastContainer />

            {/* 🔹 BOTÓN AGREGAR CON ICONO */}
            {loading ? null : (
                <>
                    {categorias?.length < limitePlan ? (
                        <button onClick={toggleModal} className='btnSave'>
                            
                            {/* 🔥 ICONO AGREGADO */}
                            <FontAwesomeIcon icon={faFolderPlus} />

                            <span>Agregar</span>
                        </button>
                    ) : (
                        <button onClick={alertPlan} className='btnSave'>

                            {/* 🔥 ICONO TAMBIÉN AQUÍ */}
                            <FontAwesomeIcon icon={faFolderPlus} />

                            <span>Agregar</span>
                        </button>
                    )}
                </>
            )}

            {/* 🔹 MODAL */}
            {modalOpen && (
                <div className='modal'>
                    <div className='modal-content'>

                        {/* 🔹 HEADER */}
                        <div className='deFlexBtnsModal'>
                            <button className='selected'>Agregar Categoria</button>
                            <span className="close" onClick={toggleModal}>
                                &times;
                            </span>
                        </div>

                        {/* 🔹 FORM */}
                        <form>

                            <fieldset>
                                <legend>Categoría</legend>

                                <input
                                    type='text'
                                    name='categoria'
                                    value={categoria}
                                    onChange={(e) => setCategoria(e.target.value)}
                                    placeholder="Ej: Bebidas"
                                />
                            </fieldset>

                            {/* 🔹 IMAGEN OPCIONAL */}
                            <fieldset>
                                <legend>Imagen (opcional)</legend>
                                <input
                                    type='file'
                                    accept='image/*'
                                    style={{ marginTop: '4px', fontSize: '13px' }}
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        setImagen(file || null);
                                        setPreviewImagen(file ? URL.createObjectURL(file) : null);
                                    }}
                                />
                                {previewImagen && (
                                    <img
                                        src={previewImagen}
                                        alt="preview"
                                        style={{
                                            marginTop: '8px',
                                            width: '100%',
                                            maxHeight: '120px',
                                            objectFit: 'cover',
                                            borderRadius: '6px',
                                            border: '1px solid #e2e8f0'
                                        }}
                                    />
                                )}
                            </fieldset>

                            {/* 🔹 BOTÓN */}
                            {mensaje ? (
                                <button type='button' className='btnLoading' disabled>
                                    {mensaje}
                                </button>
                            ) : (
                                <button
                                    type='button'
                                    onClick={crear}
                                    className='btnPost'
                                    disabled={!categoria.trim() || existe}
                                >
                                    Agregar
                                </button>
                            )}

                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}